<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <input
      #box
      class="form-control"
      type="number"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [formControlName]="control.key"
      [min]="control.min"
      [max]="control.max"
      [step]="control.step"
      [attr.disabled]="control.disabled ? 'disabled' : null"
      (input)="control.onInput(box)"
      (keypress)="control.onKeyPress($event)"
      (paste)="control.onPaste($event)"
    />
    <div *ngIf="(formGroup?.controls)[control?.key]?.errors?.isNotInteger" class="invalid-feedback d-block">
      {{ 'DynamicMinMax.WholeNumber' | i18next }}
    </div>
  </div>
</div>
